
/**
 * @nullable
 */
export type CreateTweetJsonBodyTweetType = typeof CreateTweetJsonBodyTweetType[keyof typeof CreateTweetJsonBodyTweetType] | null;


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateTweetJsonBodyTweetType = {
  ORIGINAL: 'ORIGINAL',
  REPLY: 'REPLY',
  QUOTE: 'QUOTE',
} as const;
